import { BREAKPOINTS } from '@consts';
import { useEffect, useState } from 'react';

export function useBreakpoint(breakpoint: keyof typeof BREAKPOINTS) {
  const [isReached, setIsReached] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const mql = window.matchMedia(`(min-width: ${BREAKPOINTS[breakpoint]}px)`);
    const onMqlChange = (e: MediaQueryListEvent) => {
      setIsReached(e.matches);
    };

    const onResize = () => {
      setIsReached(window.innerWidth >= BREAKPOINTS[breakpoint]);
    };

    mql.addEventListener('change', onMqlChange);
    window.addEventListener('resize', onResize);

    setIsReached(window.innerWidth >= BREAKPOINTS[breakpoint]);

    return () => {
      mql.removeEventListener('change', onMqlChange);
      window.removeEventListener('resize', onResize);
    };
  }, [breakpoint]);

  return isReached;
}
